var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AppSettings } from 'app/app.settings';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppinfoService } from './appinfo.service';
import { CommonRequestService } from './common-request.service';
import { LayerQcService } from './layer-qc.service';
import { UserService } from './user.service';
import { v1 as uuidv1 } from 'uuid';
import { SocketService } from './socket.service';
import * as i0 from "@angular/core";
import * as i1 from "./appinfo.service";
import * as i2 from "./common-request.service";
import * as i3 from "./layer-qc.service";
import * as i4 from "./socket.service";
import * as i5 from "./user.service";
var InterlayerReportService = /** @class */ (function () {
    function InterlayerReportService(appinfoService, requestService, qcService, socketService, userService) {
        this.appinfoService = appinfoService;
        this.requestService = requestService;
        this.qcService = qcService;
        this.socketService = socketService;
        this.userService = userService;
        this.selectedReportRecordsBS = new BehaviorSubject(null);
        this.selectedReportBS = new BehaviorSubject(null);
        // // This selectedReportTypeInDropdownBS is the value in report type dropdown list. It can be different than selectedReport.type when the value is ALL
        // selectedReportTypeInDropdownBS: BehaviorSubject<InterlayerReportType> = new BehaviorSubject(null);
        this.reportListBS = new BehaviorSubject(null);
        // NOTE: reportTypeBS is a RESULT of 1.selectedReportBS change 2.reportListBS change
        this.reportTypeBS = new BehaviorSubject(null);
        this.reportFilterInfoBS = new BehaviorSubject({
            filterOptions: []
        });
        this.requestData = new Subject();
        // Qc messages by processId
        this.qrLogs = new BehaviorSubject({});
        this.onQrFinish = new Subject();
    }
    // Get report data (other than FISHBONE)
    InterlayerReportService.prototype.getQrOther = function (layerIdSbj, layerIdRef, qaCodes, bbox, paging) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qrOther';
            var params = {
                layerIdSbj: layerIdSbj,
                layerIdRef: layerIdRef
            };
            if (qaCodes) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (bbox) {
                params.bbox = JSON.stringify(bbox);
            }
            if (paging) {
                _this.requestService.setParamsPaging(params, paging);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, reject(err)];
            }); }); });
        });
    };
    InterlayerReportService.prototype.getQrOverlay = function (layerIdSbj, layerIdRef, qaCodes, bbox, paging) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qrOverlay';
            var params = {
                layerIdSbj: layerIdSbj,
                layerIdRef: layerIdRef
            };
            if (qaCodes) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (bbox) {
                params.bbox = JSON.stringify(bbox);
            }
            if (paging) {
                _this.requestService.setParamsPaging(params, paging);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, reject(err)];
            }); }); });
        });
    };
    // Generate
    InterlayerReportService.prototype.qrInterlayer = function (reportType, model, editFilter) {
        return __awaiter(this, void 0, void 0, function () {
            var url, userInfo, body, tempProcessId;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AppSettings.serviceRootUrl + 'azgiv/qrInterlayer';
                        userInfo = this.userService.getUserInfo();
                        body = {
                            userSubscriptionId: userInfo.userSubId,
                            sessionId: this.appinfoService.getSessionUuid(),
                            qrFishbone: reportType === 'ALL' || reportType === 'FISHBONE',
                            qrOverlay: reportType === 'ALL' || reportType === 'OVERLAY'
                        };
                        if (model) {
                            body.model = model;
                        }
                        if (editFilter) {
                            body.editFilter = JSON.stringify(editFilter);
                        }
                        tempProcessId = uuidv1();
                        this.socketService.onInitProcess.next({
                            tempId: tempProcessId,
                            processType: 'QR'
                        });
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this.requestService.requestPost(url, body, function (rsp) {
                                    var processesById = _this.qrLogs.getValue();
                                    var processId = rsp.data.content;
                                    _this.socketService.onInitProcess.next({
                                        tempId: tempProcessId,
                                        processId: processId,
                                        processType: 'QR'
                                    });
                                    var process = _this.socketService.registerProcessById(rsp.data.content, processesById);
                                    _this.qrLogs.next(processesById);
                                    resolve({
                                        processId: processId
                                    });
                                }, function (err) { return reject(err); });
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InterlayerReportService.prototype.getQrReportTabs = function (reportType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qrReportTabs';
            var params = {
                customerId: _this.userService.getCustomerIdByType()
            };
            if (reportType) {
                params.gqrType = reportType;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var reports = [];
                if (rsp.data) {
                    rsp.data.forEach(function (i) {
                        var subjectLayerCateCode = Object.keys(i.sbj_layer)[0];
                        var subjectLayerId = i.sbj_layer[subjectLayerCateCode];
                        var subjectLayerCate = _this.appinfoService.layerTypeList.find(function (t) { return t.code === subjectLayerCateCode; });
                        i.ref_layers.forEach(function (ref) {
                            var refLayerCateCode = Object.keys(ref)[0];
                            var refLayerId = ref[refLayerCateCode];
                            var refLayerCate = _this.appinfoService.layerTypeList.find(function (t) { return t.code === refLayerCateCode; });
                            var report = {
                                subjectLayerCate: subjectLayerCate.code,
                                // subjectCateShort: subjectLayerCate.nameShort,
                                subjectLayerId: subjectLayerId,
                                refLayerCate: refLayerCate.code,
                                // refCateShort: refLayerCate.nameShort,
                                refLayerId: refLayerId,
                                label: subjectLayerCate.nameShort + " - " + refLayerCate.nameShort,
                                type: i.gqr_type
                            };
                            reports.push(report);
                        });
                    });
                }
                resolve(reports);
            }, function (err) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, reject(err)];
            }); }); });
        });
    };
    InterlayerReportService.prototype.updateQrFilterOptions = function (reportType, layerId1, layerId2) {
        return __awaiter(this, void 0, void 0, function () {
            var filterOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!reportType || !layerId1 || !layerId2)) return [3 /*break*/, 1];
                        filterOptions = [];
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getQrFilterOptions(reportType, layerId1, layerId2)];
                    case 2:
                        filterOptions = _a.sent();
                        filterOptions.forEach(function (i) { return i.isSelected = !!i.count; }); // Default select all that has count
                        _a.label = 3;
                    case 3:
                        this.reportFilterInfoBS.next({
                            filterOptions: filterOptions
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    InterlayerReportService.prototype.getQrFilterOptions = function (reportType, layerId1, layerId2) {
        return __awaiter(this, void 0, void 0, function () {
            var cusId, all, allQaRules;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cusId = this.userService.getCustomerIdByType();
                        all = [];
                        return [4 /*yield*/, this.qcService.getQaRules(cusId, reportType, null, layerId1, layerId2, 'code')];
                    case 1:
                        allQaRules = _a.sent();
                        allQaRules.forEach(function (d) {
                            var obj = {
                                name: d.ruleName,
                                value: d.code,
                                count: d.count,
                                descriptionLong: d.describLong,
                                errorLevel: d.errorLevel,
                                // isSelected: isSelected, // TODO
                                type: d.type
                            };
                            all.push(obj);
                        });
                        // Put the ones with count in the front
                        all.sort(this.qcService.sortFilterByCount);
                        return [2 /*return*/, all];
                }
            });
        });
    };
    InterlayerReportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InterlayerReportService_Factory() { return new InterlayerReportService(i0.ɵɵinject(i1.AppinfoService), i0.ɵɵinject(i2.CommonRequestService), i0.ɵɵinject(i3.LayerQcService), i0.ɵɵinject(i4.SocketService), i0.ɵɵinject(i5.UserService)); }, token: InterlayerReportService, providedIn: "root" });
    return InterlayerReportService;
}());
export { InterlayerReportService };
